import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import StoreIcon from "@mui/icons-material/Store";

const plans = ["Gold", "Diamond Special", "Diamond", "Platinum"];

const ServiceListCard = ({ listData, classes }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => new Date(dateString).getUTCFullYear();

  const handleNavigateToStore = (event, id) => {
    event.stopPropagation();
    navigate("/neighbour/" + id);
  };

  const handleNavigateToListing = (item) => {
    navigate(`/services/${item.service_id}/subService/${item.sub_service_id}/listings/${item.id}`);
  };

  return (
    <>
      {listData.map((item) => (
        <Box
          key={item.id}
          onClick={() => handleNavigateToListing(item)}
          sx={{
            backgroundColor: "#1a1a1a",
            border: "1px solid #2a2a2a",
            borderRadius: "12px",
            overflow: "hidden",
            cursor: "pointer",
            transition: "all 0.25s ease",
            "&:hover": {
              border: "1px solid #FFC001",
              transform: "translateY(-2px)",
              "& .card-name": { color: "#FFC001" },
            },
          }}
        >
          {/* Image */}
          <Box sx={{ position: "relative", height: "160px", overflow: "hidden" }}>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                backgroundImage: `url(${item?.media?.[0]?.url})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                transition: "transform 0.3s ease",
                "&:hover": { transform: "scale(1.05)" },
              }}
            />
            {/* Price badge */}
            <Box
              sx={{
                position: "absolute",
                bottom: 8,
                right: 8,
                backgroundColor: "rgba(255,192,1,0.92)",
                color: "#000",
                fontWeight: 800,
                fontSize: "13px",
                px: 1.2,
                py: 0.3,
                borderRadius: "20px",
              }}
            >
              ${item.price}
            </Box>
          </Box>

          {/* Info */}
          <Box sx={{ p: 1.5 }}>
            <Typography
              className="card-name"
              noWrap
              sx={{ color: "#fff", fontWeight: 700, fontSize: "14px", transition: "color 0.2s", mb: 0.5 }}
            >
              {item.name}
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              {plans.includes(item?.seller?.user?.subscriptions?.[0]?.plan?.name) ? (
                <Box
                  onClick={(e) => handleNavigateToStore(e, item?.seller?.store?.id)}
                  sx={{ display: "flex", alignItems: "center", gap: 0.5, maxWidth: "75%" }}
                >
                  <StoreIcon sx={{ color: "#FFC001", fontSize: 14 }} />
                  <Typography noWrap sx={{ color: "#FFC001", fontSize: "11px", fontWeight: 600 }}>
                    {item?.seller?.store?.brand_name}
                  </Typography>
                </Box>
              ) : (
                <Box />
              )}
              <Typography sx={{ color: "#444", fontSize: "11px" }}>
                {formatDate(item.created_at)}
              </Typography>
            </Box>
          </Box>
        </Box>
      ))}
    </>
  );
};

export default ServiceListCard;
